// import { Link } from "react-router-dom";
import { Link } from "react-router-dom";
import {
    // FeedPostDropDown,
    IncidentLocation,
    MediaType,
    PostText,
    PostUserBlock,
    SocialCount
} from "ui";
import {
    CustomComponentProps,
    MarkFeedPostObj
} from "utils/types/general.types";
export type MarkFeedPostProps = CustomComponentProps & {
    post: MarkFeedPostObj;
    showLink?: boolean;
};

const MarkFeedPost = ({ post, showLink = true }: MarkFeedPostProps) => {
    return (
        <div className="card is-post relative">
            {showLink && (
                <Link
                    to={`/post/${post.id}`}
                    className="absolute float-link"
                ></Link>
            )}
            {/* <!-- Main wrap --> */}
            <div className={`content-wrap`}>
                {/* <!-- Post header --> */}
                <div
                    className="post-mark flex justify-start"
                    // style={{ paddingBottom: 0 }}
                >
                    <span className="relative z-2">
                        {post.isHashtag ? `#` : ""}
                        {post.hashtag}
                    </span>
                </div>
                <div className="card-heading">
                    {/* <!-- User meta --> */}
                    <PostUserBlock user={post.user} time={post.time} />
                    {/* Right side dropdown */}
                    {/* <FeedPostDropDown /> */}
                </div>
                {/* <!-- /Post header --> */}

                {/* <!-- Post body --> */}
                <div className="card-body">
                    {post.isIncident ? (
                        <IncidentLocation location={post.location || ""} />
                    ) : (
                        ""
                    )}
                    {/* <!-- Post body text --> */}
                    <PostText text={post.text} />
                    {/* <!-- Featured image --> */}
                    <MediaType mediaType={post.mediaType} />

                    {/* <PostActions setOpenComments={setOpenComments} /> */}
                </div>
                {/* <!-- /Post body --> */}

                {/* <!-- Post footer --> */}
                <div className="card-footer">
                    {/* <!-- Post statistics --> */}
                    <SocialCount counts={post.socialCount} postId={post.id} />
                </div>
                {/* <!-- /Post footer --> */}
                {/* <div className="d-flex flex-j-end mb-20 pr-20">
                    <Link
                        to={`/post/${post.hashtag}/`}
                        className="cursor-pointer blue-text ml-auto"
                        // onClick={() => setShowThreads(true)}
                    >
                        View More
                    </Link>
                </div> */}
            </div>
        </div>
    );
};

export default MarkFeedPost;
